import { ToolSchema, ToolImplementation, ToolResult } from '../tool-types';
import { getCurrentMetroStateId } from '@/config/metro-conversation-states';

export const supervisorToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'get_coaching_advice',
  description:
    'Get structured coaching guidance for the current career coaching state. ' +
    'Use this for analysis, recommendations, or synthesis based on the employee CV and course catalog.',
  parameters: {
    type: 'object',
    properties: {
      context: {
        type: 'string',
        description: 'One-line summary of what guidance is needed for the current state'
      }
    },
    required: ['context'],
    additionalProperties: false
  }
};

export const supervisorToolMetroImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const { context } = args ?? {};
    if (!context || typeof context !== 'string') {
      return { success: false, error: 'Invalid context parameter. Expected a non-empty string.' };
    }

    const baseUrl = ''; // Azure Functions are same-origin under the web app API
    const response = await fetch(`${baseUrl}/api/metro/coaching-advice`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        context,
        stateId: getCurrentMetroStateId()
      })
    });

    if (!response.ok) {
      const text = await response.text();
      return { success: false, error: text || 'Supervisor API error.' };
    }

    const json = await response.json();
    const advice = json?.advice;

    if (!advice) {
      return { success: false, error: 'Supervisor returned no advice.' };
    }

    return { success: true, data: advice };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error in supervisor tool'
    };
  }
};
